import { request } from './_core'

export interface ChessPuzzleData {
  id:        string
  lichessId: string
  fen:       string
  moves:     string   // space-sep UCI; first = setup move, rest = solution
  rating:    number
  themes:    string[]
}

export const chess = {
  nextPuzzle: (difficulty: 'easy' | 'medium' | 'hard') =>
    request<ChessPuzzleData>(`/chess/puzzles/next?difficulty=${difficulty}`),

  recordAttempt: (id: string, solved: boolean) =>
    request<void>(`/chess/puzzles/${id}/attempt`, {
      method: 'POST',
      body:   JSON.stringify({ solved }),
    }),
}
